module.exports = __webpack_public_path__ + "static/mobile-devices-5459f58dd3cce964c1931b349df5cae4.jpg";